export const MODAL_TYPES = {
  ACTIVITY: 'ActivityModal',
};
